export enum OrderProcessState {
    New = "New",
    Open = "Open",
    Canceled = "Canceled",
    Closed = "Closed"
}
